<div class="row-1">
  <img src="./assets/icons/no-logo-company-icon.svg" />
  <div style="width: 90%">
    <span class="corporate-name">{{ salesHistoryCompanySummary.getCorporateName() }}</span>
    <span class="fiscal-number">CNPJ: {{ salesHistoryCompanySummary.getFiscalNumber() | companyFederalNumber }}</span>
  </div>
</div>

<div class="row-2">
  <span>{{ salesHistoryCompanySummary.getProductSoldCount() }} Produtos vendidos</span>
</div>

<div class="row-3">
  <span>Top {{ salesHistoryCompanySummary.getSalesHistoryProductList().length }} mais vendidos</span>

  <div class="sales-history-company-btn" (click)="detail()">
    <span>VER TODOS</span>
  </div>
</div>

<div class="row-4">
  <div class="item" *ngIf="!!salesHistoryCompanySummary.getSalesHistoryProductList()[0]">
    <span class="product-name">{{ salesHistoryCompanySummary.getSalesHistoryProductList()[0].getProductName() }}</span>
    <div class="product-count" style="background-color: #28c76f">
      <span>{{ salesHistoryCompanySummary.getSalesHistoryProductList()[0].getSoldItemQuantity() }}</span>
    </div>
  </div>

  <div class="item" *ngIf="!salesHistoryCompanySummary.getSalesHistoryProductList()[0]">
    <span class="product-name">-</span>
    <div class="product-count" style="background-color: #28c76f">
      <span>0</span>
    </div>
  </div>

  <div class="item" *ngIf="!!salesHistoryCompanySummary.getSalesHistoryProductList()[1]">
    <span class="product-name">{{ salesHistoryCompanySummary.getSalesHistoryProductList()[1].getProductName() }}</span>
    <div class="product-count" style="background-color: #e95456">
      <span>{{ salesHistoryCompanySummary.getSalesHistoryProductList()[1].getSoldItemQuantity() }}</span>
    </div>
  </div>

  <div class="item" *ngIf="!salesHistoryCompanySummary.getSalesHistoryProductList()[1]">
    <span class="product-name">-</span>
    <div class="product-count" style="background-color: #e95456">
      <span>0</span>
    </div>
  </div>

  <div class="item" *ngIf="!!salesHistoryCompanySummary.getSalesHistoryProductList()[2]">
    <span class="product-name">{{ salesHistoryCompanySummary.getSalesHistoryProductList()[2].getProductName() }}</span>
    <div class="product-count" style="background-color: #8c64d2">
      <span>{{ salesHistoryCompanySummary.getSalesHistoryProductList()[2].getSoldItemQuantity() }}</span>
    </div>
  </div>

  <div class="item" *ngIf="!salesHistoryCompanySummary.getSalesHistoryProductList()[2]">
    <span class="product-name">-</span>
    <div class="product-count" style="background-color: #8c64d2">
      <span>0</span>
    </div>
  </div>

  <div class="item" *ngIf="!!salesHistoryCompanySummary.getSalesHistoryProductList()[3]">
    <span class="product-name">{{ salesHistoryCompanySummary.getSalesHistoryProductList()[3].getProductName() }}</span>
    <div class="product-count" style="background-color: #ffa84c">
      <span>{{ salesHistoryCompanySummary.getSalesHistoryProductList()[3].getSoldItemQuantity() }}</span>
    </div>
  </div>

  <div class="item" *ngIf="!salesHistoryCompanySummary.getSalesHistoryProductList()[3]">
    <span class="product-name">-</span>
    <div class="product-count" style="background-color: #ffa84c">
      <span>0</span>
    </div>
  </div>

  <div class="item" *ngIf="!!salesHistoryCompanySummary.getSalesHistoryProductList()[4]">
    <span class="product-name">{{ salesHistoryCompanySummary.getSalesHistoryProductList()[4].getProductName() }}</span>
    <div class="product-count" style="background-color: #4dd2ff">
      <span>{{ salesHistoryCompanySummary.getSalesHistoryProductList()[4].getSoldItemQuantity() }}</span>
    </div>
  </div>

  <div class="item" *ngIf="!salesHistoryCompanySummary.getSalesHistoryProductList()[4]">
    <span class="product-name">-</span>
    <div class="product-count" style="background-color: #4dd2ff">
      <span>0</span>
    </div>
  </div>

  <div class="item" *ngIf="!!salesHistoryCompanySummary.getSalesHistoryProductList()[5]">
    <span class="product-name">{{ salesHistoryCompanySummary.getSalesHistoryProductList()[5].getProductName() }}</span>
    <div class="product-count" style="background-color: #f09ae9">
      <span>{{ salesHistoryCompanySummary.getSalesHistoryProductList()[5].getSoldItemQuantity() }}</span>
    </div>
  </div>

  <div class="item" *ngIf="!salesHistoryCompanySummary.getSalesHistoryProductList()[5]">
    <span class="product-name">-</span>
    <div class="product-count" style="background-color: #f09ae9">
      <span>0</span>
    </div>
  </div>
</div>
